export interface ContentTeamConfig {
  teamId: string;
  /** Served by ContentTeamPage2; `${route}2` (/ogc2, /tun-unc2) keeps working too. */
  route: string;
  /** The page's h1: a name, so it is not translated. */
  heading: string;
  /** Column order on the page. */
  hostIds: string[];
  /** Another team's `teamId`: the page can add that team's hosts as extra columns. */
  compareWith?: string;
}

export const CONTENT_TEAMS: ContentTeamConfig[] = [
  {
    teamId: 'ogc',
    route: '/ogc',
    heading: 'OGC-podcasten',
    hostIds: ['76561197983673093', '76561198205544503'],
    compareWith: 'tun-unc',
  },
  {
    teamId: 'tun-unc',
    route: '/tun-unc',
    heading: 'MeSterLund & Trun1eX',
    hostIds: ['76561198201191395', '76561198258148023'],
    compareWith: 'ogc',
  },
];
